module.exports = __webpack_public_path__ + "img/6.d0a66212.jpg";